import { params, const_var } from "../../redux/reducers/reducer";
import { addDiscountExclusionsInPayload, checkAdditionalChargesData, checkBuildingTypeCategory, setExtraOptionsVariables, detectDeviceInfo, extraAddOnRoofPitchPayload, updateDocOnSave } from "../../redux/reducers/utils";
import { saveQuote } from "../share_screen/screenShare.action";
import { cleanPayload } from "../../utils/commonUtils";
import { createUpdateService } from "../../services/quote-order.service";

export function onorderTextFiledChangeValue(e, name, keyword, flag) {
	return (dispatch) => {
		dispatch({
			type: "onorderTextFiledChangeValue",
			event: e,
			value: name,
			keyword: keyword,
			flagg: flag
		});
	};
}
export function handleOrderModal(e) {
	return (dispatch) => {
		dispatch({
			type: "handleOrderModal",
			payload: e
		});
	};
}

export function onSubmitCheckout(e) {
	return (dispatch) => {
		dispatch({
			type: "onOrderSubmitCheckout",
			event: e
		});

		if (const_var.checkValidate == false) {
			let isAddressDataDelete = const_var.crmSetting.pre_quote_form == true && const_var.preQuoteApiCalled == true && const_var.preQuoteError == false && const_var.loginSession == false ? false : true;
			const_var.activeTab = "buildingtypetab";
			const_var.post_data["card_detail"] = {};
			var newAddress = [];
			const_var.showProcessLoader = true;
			const_var.submitCheckoutBtn = true;
			for (let i = 0; i <= e.target.length - 1; i++) {
				const arr = [{ key: e.target[i].name, value: e.target[i].value }];
				if (arr[0].key == "phone_no") {
					const_var.post_data["mobile_no"] = arr[0].value;
					const_var.post_data["phone_no"] = arr[0].value;
				} else {
					const_var.post_data[arr[0].key] = arr[0].value;
				}
				//const_var.post_data[arr[0].key] = arr[0].value;
			}
			const_var.post_data.shipping_state = const_var.shippingState;
			const_var.post_data["billing_state"] = const_var.billingState;
			if (const_var.billingAddressCheckbox == true) {
				const_var.post_data["billing_address_line_1"] = const_var.post_data["shipping_address_line_1"];
				const_var.post_data["billing_city"] = const_var.post_data["shipping_city"];
				const_var.post_data["billing_state"] = const_var.post_data["shipping_state"];
				const_var.post_data["billing_zipcode"] = const_var.post_data["shipping_zipcode"];
				newAddress.push({
					address_line_1: const_var.post_data["shipping_address_line_1"],
					address_line_2: "",
					zipcode: const_var.post_data["shipping_zipcode"],
					county: "",
					state: const_var.post_data["shipping_state"],
					city: const_var.post_data["shipping_city"],
					is_billing: 1,
					is_installation: 1
				});
			} else {
				newAddress.push({
					address_line_1: const_var.post_data["billing_address_line_1"],
					address_line_2: "",
					zipcode: const_var.post_data["billing_zipcode"],
					county: "",
					state: const_var.post_data["billing_state"],
					city: const_var.post_data["billing_city"],
					is_billing: 1
				});
				newAddress.push({
					address_line_1: const_var.post_data["shipping_address_line_1"],
					address_line_2: "",
					zipcode: const_var.post_data["shipping_zipcode"],
					county: "",
					state: const_var.post_data["shipping_state"],
					city: const_var.post_data["shipping_city"],
					is_installation: 1
				});
			}
			const_var.post_data["address"] = newAddress;
			if (const_var.post_data["building"].leanto != undefined && const_var.post_data["building"].leanto.length > 0) {
				if (const_var.post_data["building"].leanto.length > 1) {
					const_var.post_data["building"].leanto[0].alignment =
						const_var.post_data["building"].leanto[0].leanto_type == 1 ? const_var.TypeAlingnment[params.leantoAlignmentLeft] : const_var.TypeAlingnment[params.leantoAlignmentRight];
					const_var.post_data["building"].leanto[1].alignment =
						const_var.post_data["building"].leanto[1].leanto_type == 1 ? const_var.TypeAlingnment[params.leantoAlignmentLeft] : const_var.TypeAlingnment[params.leantoAlignmentRight];
				} else {
					const_var.post_data["building"].leanto[0].alignment =
						const_var.post_data["building"].leanto[0].leanto_type == 1 ? const_var.TypeAlingnment[params.leantoAlignmentLeft] : const_var.TypeAlingnment[params.leantoAlignmentRight];
				}
			}

			if (const_var.post_data.building != undefined && const_var.post_data["building"].other_building_type_name == "") {
				params.other_building_type_name = params.building_type_name + " - " + params.p_w + " x " + params.p_d + " x " + params.p_h;
				const_var.post_data["building"].other_building_type_name = params.other_building_type_name;
				const_var.post_data["building"].name = params.other_building_type_name;
			}
			if (const_var.post_data["building"].leanto != undefined && const_var.post_data["building"].leanto.length > 0) {
				for (var i = 0; i <= const_var.post_data["building"].leanto.length - 1; i++) {
					if (const_var.post_data["building"].leanto[i].leanto_type == 1) {
						if (params.leanStyle.left === "gable" && params.p_d == params.lean_p_w) {
							const_var.post_data["building"].leanto[i].alignment = "center";
						} else {
							const_var.post_data["building"].leanto[i].alignment = const_var.TypeAlingnment[params.leantoAlignmentLeft];
						}
					}
					if (const_var.post_data["building"].leanto[i].leanto_type == 2) {
						if (params.leanStyle.right === "gable" && params.p_d == params.leanR_p_w) {
							const_var.post_data["building"].leanto[i].alignment = "center";
						} else {
							const_var.post_data["building"].leanto[i].alignment = const_var.TypeAlingnment[params.leantoAlignmentRight];
						}
					}
					if (const_var.post_data["building"].leanto[i].leanto_type == 3) {
						if (params.leanStyle.front === "gable" && params.p_w == params.leanF_p_w) {
							const_var.post_data["building"].leanto[i].alignment = "center";
						} else {
							const_var.post_data["building"].leanto[i].alignment = const_var.endLeanAlingnmentType[params.leantoAlignmentFront];
						}
					}
					if (const_var.post_data["building"].leanto[i].leanto_type == 4) {
						if (params.leanStyle.back === "gable" && params.p_w == params.leanB_p_w) {
							const_var.post_data["building"].leanto[i].alignment = "center";
						} else {
							const_var.post_data["building"].leanto[i].alignment = const_var.endLeanAlingnmentType[params.leantoAlignmentBack];
						}
					}
				}
			}
			if (const_var.post_data["building"].surcharge_amount != 0) {
				const_var.post_data["building"].surcharge_taxable = const_var.post_data["building"].surcharge_taxable == undefined ? 0 : const_var.post_data["building"].surcharge_taxable;
			}
			if (const_var.dealer_discount_label != undefined && const_var.dealer_discount_label != "") {
				const_var.post_data["building"].dealer_discount_label = const_var.dealer_discount_label;
			}
			if (const_var.post_data["building"].discount_amount == undefined || const_var.post_data["building"].discount_amount == 0) {
				const_var.manufacturer_discount_label = "";
				const_var.post_data["building"].manufacturer_discount_label = "";
			}
			if (const_var.manufacturer_discount_label != undefined && const_var.manufacturer_discount_label != "") {
				const_var.post_data["building"].manufacturer_discount_label = const_var.manufacturer_discount_label;
			}
			const_var.post_data["building"].installationsurfaceChange = true;
			const_var.post_data["building"].old_permit_Fee = const_var.exact_order_permit_fee;
			const_var.post_data["building"].is_showBackgroundImage = const_var.crmSetting.is_show_background;
			const_var.post_data["building"].tax_zipcode = const_var.post_data["billing_zipcode"];
			const_var.post_data["building"].other_building_type_name = params.other_building_type_name;
			const_var.post_data["building"].payment_mode = const_var.paymentOptionObj[params.paymentmode];
			const_var.post_data["building"].name = params.other_building_type_name;
			const_var.post_data["name"] = const_var.post_data["building"].other_building_type_name;
			const_var.post_data["building"].custom_building = const_var.hide_price_calculation;
			const_var.post_data["custom_building"] = const_var.hide_price_calculation;
			const_var.post_data["pdf_price_breakdown"] = const_var.price_breakdown_key[const_var.crmSetting.is_module_name];
			const_var.post_data["api_token"] = const_var.crmSetting.api_token;
			const_var.post_data["charge_card"] = 1;
			const_var.post_data["is_quote"] = 0;
			const_var.post_data["questions"] = const_var.estimator_QuestionAnswer;
			const_var.post_data["module"] = "order";
			const_var.post_data["module_id"] = "";
			const_var.post_data["sub_module"] = "";
			const_var.post_data["sub_module_id"] = "";
			const_var.post_data["form_type"] = "3d_v4";
			const_var.post_data["created_source"] = "3d_v4";
			const_var.post_data["is_api"] = 1;
			const_var.post_data["lead_source"] = "3D Estimator";
			const_var.post_data["referral_source"] = const_var.referrer == "" ? document.referrer : const_var.referrer;
			if (const_var.post_data["sensei_sales_id"] != undefined && const_var.post_data["sensei_sales_id"] != "") {
				const_var.post_data["lead_source"] = "Sensei Sales Id";
			}
			if (const_var.crmSetting.utm_medium != undefined && const_var.crmSetting.utm_medium != "") {
				const_var.post_data["utm_medium"] = const_var.crmSetting.utm_medium;
			}
			if (const_var.crmSetting.utm_term != undefined && const_var.crmSetting.utm_term != "") {
				const_var.post_data["utm_term"] = const_var.crmSetting.utm_term;
			}
			if (const_var.crmSetting.utm_campaign != undefined && const_var.crmSetting.utm_campaign != "") {
				const_var.post_data["utm_campaign"] = const_var.crmSetting.utm_campaign;
			}
			if (const_var.crmSetting.utm_content != undefined && const_var.crmSetting.utm_content != "") {
				const_var.post_data["utm_content"] = const_var.crmSetting.utm_content;
			}
			const_var.post_data["build_type"] = "added_building";
			const_var.post_data["source"] = const_var.crmSetting.utm_source != undefined && const_var.crmSetting.utm_source != "" ? const_var.crmSetting.utm_source : const_var.crmSetting.source;
			//const_var.post_data['source'] = const_var.crmSetting.source;
			const_var.post_data["page"] = const_var.crmSetting.page;
			const_var.post_data["form"] = "Order Form";
			const_var.post_data["building"].surface_level = params.job_site_level;
			const_var.post_data["building"].electricity = params.power_avail;
			const_var.post_data["building"].additional_note = params.additional_note;
			const_var.post_data["sign_jpeg"] = const_var.sign_jpeg;
			const_var.post_data["collect_card"] = 1;
			const_var.post_data["building_data"] = const_var.SendAPIBuildingData;
			const_var.post_data["building_data"]["color_data"] = const_var?.color;
			const_var.post_data["building_data"]["component_data"] = const_var.componentData;
			const_var.post_data["building_data"]["siding_material_data"] = const_var.mainSidingOptions;
			const_var.post_data["pricing_data"] = const_var.isLTBuilding ? const_var.holdPricingResponse : const_var.a_p_d_a;
			const_var.post_data["estimator_domain"] = const_var.crmSetting.main_domain_url;

			const_var.post_data["card_detail"]["cardnumber"] = const_var.post_data.cardnumber;
			const_var.post_data["card_detail"]["expirydate"] = const_var.post_data.expirydate;
			const_var.post_data["card_detail"]["cvv"] = const_var.post_data.cvv;
			const_var.post_data["card_detail"]["cardholder_name"] = const_var.post_data.cardholder;

			delete const_var.post_data["billing_address_line_1"];
			delete const_var.post_data["billing_city"];
			delete const_var.post_data["billing_state"];
			delete const_var.post_data["billing_zipcode"];

			delete const_var.post_data["shipping_city"];

			// ####### For updating value in order_extra_items array #######
			if (
				const_var.post_data["building"].order_extra_items != undefined &&
				const_var.post_data["building"].order_extra_items.surface_level != undefined &&
				const_var.post_data["building"].order_extra_items.electricity != undefined &&
				const_var.post_data["building"].order_extra_items.job_site_level != undefined
			) {
				const_var.post_data["building"].order_extra_items.surface_level = params.job_site_level;
				const_var.post_data["building"].order_extra_items.electricity = params.power_avail;
				const_var.post_data["building"].order_extra_items.job_site_level = params.job_site_level;
			}
			const_var.post_data["building"].surface_level = params.job_site_level;
			const_var.post_data["building"].electricity = params.power_avail;
			if (isAddressDataDelete == true) {
				delete const_var.post_data["shipping_address_line_1"];
				delete const_var.post_data["shipping_state"];
				delete const_var.post_data["shipping_zipcode"];
			}
			// ####### For updating value in order_extra_items array #######
			if (
				const_var.post_data["building"].order_extra_items != undefined &&
				const_var.post_data["building"].order_extra_items.surface_level != undefined &&
				const_var.post_data["building"].order_extra_items.electricity != undefined &&
				const_var.post_data["building"].order_extra_items.job_site_level != undefined
			) {
				const_var.post_data["building"].order_extra_items.surface_level = params.job_site_level;
				const_var.post_data["building"].order_extra_items.electricity = params.power_avail;
				const_var.post_data["building"].order_extra_items.job_site_level = params.job_site_level;
			}
			const_var.post_data["building"].surface_level = params.job_site_level;
			const_var.post_data["building"].electricity = params.power_avail;
			const_var.checkStripeID = true;
			const_var.additionalChargeArr = checkAdditionalChargesData();
			const_var.post_data["building"].AdditionalCharges = const_var.additionalChargeArr;
			if ((const_var.post_data?.building?.insulation == "full" || const_var.post_data?.building?.insulation == "roof_only") && const_var.post_data?.building?.leanto?.length > 0) {
				const_var.post_data?.building?.leanto.forEach((lean) => {
					delete lean.insulation;
					delete lean.insulation_type;
					delete lean.insulation_price;
				});
			}
			const_var.post_data.building.is_edit_extra_labour = const_var.is_edit_extra_labour || false;
			const_var.post_data["building"]["device_details"] = detectDeviceInfo();
			// extraAddOnRoofPitchPayload();
			updateDocOnSave();
			if (const_var.post_data["cardnumber"] != "" && const_var.post_data["cardnumber"] != undefined) {
				const_var.post_data["building"]["payment_mode"]["type"] = "card";
			}
			if (const_var.isKLinkEnable && const_var.post_data["building"].order_extra_items != undefined && const_var.post_data["building"].order_extra_items.additional_note != undefined) {
				delete const_var.post_data["building"].order_extra_items.additional_note;
			}
			if (params.company_id && const_var.isKLinkEnable) {
				const_var.post_data["company_id"] = params.company_id;
				const_var.post_data["estimator_domain"] = const_var.crmSetting.main_domain_url;
			}
			if (params.m_s_n == 3 && const_var.post_data?.building_data?.building?.length > 0 && const_var.post_data?.building?.engineer_drawings_name != "None") {
				const_var.post_data.building_data.building.forEach((building, index) => {
					if (building.drawings?.length > 0) {
						let findNoneIndex = building.drawings.findIndex((obj) => obj?.name.toLowerCase() == "none");
						if (findNoneIndex > -1) {
							const_var.post_data.building_data.building[index].drawings.splice(findNoneIndex, 1);
						}
					}
				});
			}
			const_var.post_data.payment_type = const_var.paymentOption.type;
			if (const_var.stripe["checkout_type"] == "stripe") {
				window.Stripe.card.createToken(
					{
						number: const_var.post_data["cardnumber"],
						exp_month: const_var.post_data["expirydate"].split("/")[0],
						exp_year: const_var.post_data["expirydate"].split("/")[1],
						cvc: const_var.post_data["cvv"]
					},
					(status, response) => {
						if (status === 200) {
							delete const_var.post_data["card_detail"]["cardnumber"];
							delete const_var.post_data["card_detail"]["expirydate"];
							delete const_var.post_data["card_detail"]["cvv"];
							delete const_var.post_data["cardnumber"];
							delete const_var.post_data["cardholder"];
							delete const_var.post_data["cvv"];
							delete const_var.post_data["expirydate"];
							const_var.checkStripeID = true;
							const_var.post_data.stripe_token = response.id;
							if (const_var.checkStripeID == true) {
								dispatch(onSubmitCheckoutApi(e));
							}
						} else {
							const_var.checkStripeID = false;
							if (response.error) {
								dispatch(onSubmitCheckoutApiErrorhandling(e, response.error.message));
							}
						}
					}
				);
			} else {
				delete const_var.post_data["cardnumber"];
				delete const_var.post_data["cardholder"];
				delete const_var.post_data["cvv"];
				delete const_var.post_data["expirydate"];
				dispatch(onSubmitCheckoutApi(e));
			}
		}
	};
}

export function onSubmitCheckoutApiErrorhandling(e, message) {
	return {
		type: "onSubmitCheckoutApiErrorhandling",
		event: e,
		value: message
	};
}

export function onSubmitCheckoutApi(e) {
	if (const_var.crmSetting.is_zipcode_screen != undefined && const_var.crmSetting.is_zipcode_screen == true) {
		const_var.post_data["building"].state_mfg_zipcode = const_var.state_mfg_zipcode;
	}
	const_var.post_data["building"].installationsurfaceChange = true;
	const_var.post_data["building"].old_permit_Fee = const_var.exact_order_permit_fee;
	if (
		const_var.editAPIDataByResponse != undefined &&
		const_var.editAPIDataByResponse.data != undefined &&
		const_var.editAPIDataByResponse != undefined &&
		const_var.editAPIDataByResponse.data.main_created_at != undefined
	) {
		const_var.post_data["building"].create_at_date =
			const_var.editAPIDataByResponse.data.request_data != undefined &&
			const_var.editAPIDataByResponse.data.request_data.building != undefined &&
			const_var.editAPIDataByResponse.data.request_data.building.create_at_date != undefined
				? const_var.editAPIDataByResponse.data.request_data.building.create_at_date
				: const_var.editAPIDataByResponse.data.main_created_at;

		const_var.post_data.main_created_at = const_var.editAPIDataByResponse.data.main_created_at;
	}
	const_var.post_data["building"].additional_note = params.additional_note;
	if (params.p_c_i && const_var.post_data && const_var.post_data.building) {
		const_var.post_data.building.insulation = "custom";
	}
	const_var.post_data["building"].isUpdate4ftLegLogic = const_var.isUpdate4ftLegLogic || false;
	const_var.post_data["is_generate_pdf"] = true;
	const_var.additionalChargeArr = checkAdditionalChargesData();

	const_var.post_data["building"].AdditionalCharges = const_var.additionalChargeArr;
	const_var.post_data["building"].wallOrientation = params.wallOrientation;

	let check_type_category = checkBuildingTypeCategory(const_var.post_data.building.default_building_image_name);
	const_var.post_data["building"].building_category = check_type_category.type;
	const_var.post_data["building"].building_subcategory = check_type_category.name;
	if (const_var.post_data["building"].other_building_type_name != undefined) {
		const_var.post_data["building"].building_type_name = const_var.post_data["building"].other_building_type_name;
	}
	addDiscountExclusionsInPayload(const_var);
	return (dispatch, getState) => {
		setExtraOptionsVariables(const_var);
		const payload = cleanPayload(structuredClone(const_var.post_data));
		let request = createUpdateService(const_var.crmSetting.form_action, const_var.crmSetting.is_module_name, payload, const_var.crmSetting.is_module_id);
		return request
			.then((response) => {
				getState()?.screenShareReducer?.isSharingScreen && dispatch(saveQuote(response.data));
				dispatch({
					type: "onSubmitCheckoutApi",
					event: response.data
				});
			})
			.catch(function (error) {
				console.log(error);
			});
	};
}
export function privacyPolicyCheckboxChange() {
	return (dispatch) => {
		dispatch({
			type: "privacyPolicyCheckboxChange"
		});
	};
}
export function genrateSignature(val, key) {
	const_var.sigPad = key;
	return (dispatch) => {
		dispatch({
			type: "genrateSignature",
			value: key.getTrimmedCanvas().toDataURL("image/png"),
			event: val
		});
	};
}
export function agreeTermsAndConditionCheckboxChange() {
	return (dispatch) => {
		dispatch({
			type: "agreeTermsAndConditionCheckboxChange"
		});
	};
}

export function termsAndConditionProceedBtn() {
	return (dispatch) => {
		dispatch({
			type: "termsAndConditionProceedBtn"
		});
	};
}

export function billingAddressCheckboxChange(val) {
	return (dispatch) => {
		dispatch({
			type: "billingAddressCheckboxChange",
			val: val
		});
	};
}
export function shippingStateChange(val) {
	return (dispatch) => {
		dispatch({ type: "SHIPPINGSTATECHANGE", value: val });
	};
}

export function billingStateChange(val) {
	return (dispatch) => {
		dispatch({ type: "BILLINGSTATECHANGE", value: val });
	};
}
export function updateTempPostData(val, isPostReset) {
	return (dispatch) => {
		dispatch({ type: "updateTempPostData", value: val, isPostReset: isPostReset });
	};
}
